import common from "../../../utils/common";

class userAddressDetailsController {
  constructor() {
    "ngInject"
    
  }
  
  formatDate(date) {
    if(!date) return false;
    
    return  common.formatDate(date);
  }
  
}

export default userAddressDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-address-details/user-address-details.controller.js
 **/